export default __webpack_public_path__ + "static/media/14.dcfa7685.mp3";